import React from "react";

const Popup = ({ isOpen, onClose, title, children, isHtml = false }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 bg-black/60 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen p-8">
        {/* Popup Container */}
        <div className="relative bg-white rounded-xl shadow-lg w-[90%] max-w-[580px] p-6 z-10">
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            {isHtml ? (
              <h2
                className="text-xl font-semibold text-[#142b70]"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            ) : (
              <h2 className="text-xl font-semibold text-[#142b70]">{title}</h2>
            )}
            <button
              onClick={onClose}
              className="text-[#142b70] hover:text-red-600 transition"
            >
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
              >
                <path
                  d="M9.16742 15.5794C8.97742 15.5794 8.78742 15.5094 8.63742 15.3594C8.34742 15.0694 8.34742 14.5894 8.63742 14.2994L14.2974 8.63938C14.5874 8.34938 15.0674 8.34938 15.3574 8.63938C15.6474 8.92937 15.6474 9.40937 15.3574 9.69937L9.69742 15.3594C9.55742 15.5094 9.35742 15.5794 9.16742 15.5794Z"
                  fill="#142b70"
                />
                <path
                  d="M14.8274 15.5794C14.6374 15.5794 14.4474 15.5094 14.2974 15.3594L8.63742 9.69937C8.34742 9.40937 8.34742 8.92937 8.63742 8.63938C8.92742 8.34938 9.40742 8.34938 9.69742 8.63938L15.3574 14.2994C15.6474 14.5894 15.6474 15.0694 15.3574 15.3594C15.2074 15.5094 15.0174 15.5794 14.8274 15.5794Z"
                  fill="#142b70"
                />
                <path
                  d="M14.998 22.7502H8.99805C3.56805 22.7502 1.24805 20.4302 1.24805 15.0002V9.00009C1.24805 3.57003 3.56805 1.25 8.99805 1.25H14.998C20.428 1.25 22.748 3.57003 22.748 9.00009V15.0002C22.748 20.4302 20.428 22.7502 14.998 22.7502ZM8.99805 2.75002C4.38805 2.75002 2.74805 4.39004 2.74805 9.00009V15.0002C2.74805 19.6102 4.38805 21.2502 8.99805 21.2502H14.998C19.608 21.2502 21.248 19.6102 21.248 15.0002V9.00009C21.248 4.39004 19.608 2.75002 14.998 2.75002H8.99805Z"
                  fill="#142b70"
                />
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="space-y-4">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
